import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ProfileAvatarComponent } from '@rma/profiles/public/ui-profile-avatar';
import { ShortRatingSummaryComponent } from '@rma/profiles/public/ui-short-rating-summary';

@Component({
  selector: 'rma-result-profile',
  imports: [ProfileAvatarComponent, TranslocoModule, ShortRatingSummaryComponent],
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultProfileComponent {
  @Input()
  avatar!: string;

  @Input()
  name!: string;

  @Input()
  agencyName: string | undefined;

  @Input()
  starRating!: number;

  @Input()
  totalReviews!: number;

  @Input()
  showRatingSummary!: boolean;
}
